import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface stepTrackerState {
  activeStep: number;
  stepStatusArray: ("completed" | "default")[];
}

const initialState: stepTrackerState = {
  activeStep: 0,
  stepStatusArray: ["default", "default", "default", "default"],
};

const stepTrackerSlice = createSlice({
  name: "stepTracker",
  initialState,
  reducers: {
    setActiveStep(state, action: PayloadAction<number>) {
      state.activeStep = action.payload;
    },
    setStepStatusArray(
      state,
      action: PayloadAction<("completed" | "default")[]>,
    ) {
      state.stepStatusArray = action.payload;
    },
    updateStepStatus(state, action: PayloadAction<number>) {
      const stepIndex = action.payload;
      const newStatus = [...state.stepStatusArray];

      if (stepIndex > newStatus.length) {
        return;
      }
      newStatus[stepIndex] = "completed";
      state.stepStatusArray = newStatus;
      state.activeStep = stepIndex + 1;
    },
    goBackStep(state, action: PayloadAction<number>) {
      const stepIndex = action.payload;
      if (stepIndex < 0 || stepIndex >= state.stepStatusArray.length) {
        return;
      }

      const newStatus = [...state.stepStatusArray];

      newStatus[stepIndex] = "default";
      state.stepStatusArray = newStatus;
      state.activeStep = stepIndex;
    },
  },
});

export const {
  setActiveStep,
  setStepStatusArray,
  updateStepStatus,
  goBackStep,
} = stepTrackerSlice.actions;
export default stepTrackerSlice.reducer;
